/**
 * List of available Markup for Button
 */
var ButtonMarkup;
(function (ButtonMarkup) {
    ButtonMarkup["BUTTON"] = "button";
    ButtonMarkup["INPUT"] = "input";
    ButtonMarkup["A"] = "a";
})(ButtonMarkup || (ButtonMarkup = {}));
/**
 * List of available type of Button
 */
var ButtonType;
(function (ButtonType) {
    ButtonType["BUTTON"] = "button";
    ButtonType["RESET"] = "reset";
    ButtonType["SUBMIT"] = "submit";
})(ButtonType || (ButtonType = {}));
/**
 * Button Color
 * @deprecated ButtonColor is deprecated ( ButtonVariant v4 )
 */
export var ButtonColor;
(function (ButtonColor) {
    ButtonColor["SUCCESS"] = "SUCCESS";
    ButtonColor["DANGER"] = "DANGER";
    ButtonColor["INFO"] = "INFO";
    ButtonColor["WARNING"] = "WARNING";
    ButtonColor["SECONDARY"] = "SECONDARY";
    ButtonColor["PRIMARY"] = "PRIMARY";
    ButtonColor["TERTIARY"] = "TERTIARY";
})(ButtonColor || (ButtonColor = {}));
export { ButtonMarkup, ButtonType };
//# sourceMappingURL=ButtonEnum.js.map